export class PreferenceAnnonceur {
  public id: number;
  public identifiant: string;
  public emailBoamp: string;
  constructor() {
    this.id = -1;
    this.identifiant = ""
    this.emailBoamp = ""
  }
}

export enum PreferenceAnnonceurEnum {
  IDENTIFIANT = "idannonceurboampweb",
  EMAILBOAMP = "mailcontactboampweb"
}
